import React from 'react'
import InfoModal from '../InfoModal'

interface SecureInfoModalProps {
    open: boolean
    onClose: () => void
}

// Opened from the "Private & secure" pill: explains the SSL connection
const SecureInfoModal: React.FC<SecureInfoModalProps> = ({ open, onClose }) => (
    <InfoModal open={open} onClose={onClose} titleId="secure-info-title" title="Your connection is secure">
        This page uses an encrypted SSL connection (the padlock in your browser), so the details you enter are
        protected as they travel to us. We store them securely and handle them in line with our{' '}
        <a href="https://www.sentinellegal.co.uk/privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
        </a>
        .
    </InfoModal>
)

export default SecureInfoModal
